import React, { useEffect } from "react";

import { Switch, BrowserRouter as Router, useHistory } from "react-router-dom";
import { useSelector } from "react-redux";

// Import Routes all
import { adminRoutes, managerCompanyRoutes, routes, authRoutes, taxPortalRoutes, payPortalRoutes } from "./routes/allRoutes";

// Import all middleware
import Authmiddleware from "./routes/middleware/Authmiddleware";

// layouts Format
import VerticalLayout from "./components/VerticalLayout/";
import HorizontalLayout from "./components/HorizontalLayout/";
import NonAuthLayout from "./components/NonAuthLayout";

// Plugin
import "chartjs-plugin-datalabels";
import { defaults } from "react-chartjs-2";

// Plugin css
import "flatpickr/dist/themes/material_blue.css";
import "react-perfect-scrollbar/dist/css/styles.css";
import "toastr/build/toastr.min.css";


// Import scss
import "./assets/scss/theme.scss";

// Import Firebase Configuration file
import { merge } from "lodash-es";
import Common from "./components/Common";
import NonAuthmiddleware from "./routes/middleware/NonAuthmiddleware";
import AdminAuthmiddleware from "./routes/middleware/AdminAuthmiddleware";
import ManagerCompanyAuthmiddleware from "./routes/middleware/ManagerCompanyAuthmiddleware";
import { isEmpty } from "lodash";
import { getReferrer, setThroughTaxCompanyCode } from "./utils/storage";


import queryString from "query-string";
import TaxPortalAuthmiddleware from "./routes/middleware/TaxPortalAuthmiddleware";
import PayPortalAuthmiddleware from "./routes/middleware/PayPortalAuthmiddleware";
// import TaskCommonDraftPrint from "./components/Task/TaskCommonDraftPrint";
// import { setPrint } from "./utils/print";

if (process && process.env) {
  const devToken = process.env.REACT_APP_ACCESS_TOKEN;
  const devCompanyToken = process.env.REACT_APP_COMPANY_TOKEN;

  if (devToken) {
    localStorage.setItem("accessToken", devToken);
  }
  if (devCompanyToken) {
    localStorage.setItem("companyToken", devCompanyToken);
  }
}


// Chartjs default setting
merge(defaults, {
  global: {
    defaultFontFamily: "Noto Sans",
    defaultFontSize: 13,
    defaultFontStyle: "bold",
  },
});

const App = () => {
  // 최초 접근 사이트 수집
  const history = useHistory();

  const layout = useSelector((store) => store.Layout);
  const getLayout = () => {
    let layoutCls = VerticalLayout;
    switch (layout.layoutType) {
      case "horizontal":
        layoutCls = HorizontalLayout;
        break;
      default:
        layoutCls = VerticalLayout;
        break;
    }
    return layoutCls;
  };

  const Layout = getLayout();

  const { company } = useSelector((store) => store.Profile);
  useEffect(() => {
    let documentTitle = process.env.REACT_APP_APPFULLNAME;
    if (company && !isEmpty(company)) {
      documentTitle = company.name + ' | ' + documentTitle;
    }
    document.title = documentTitle;
  }, [company]);

  useEffect(() => {
    getReferrer();
    const query = queryString.parse(history.location.search);
    if (query && query.code) {
      localStorage.clear();
      setThroughTaxCompanyCode(query.code);
    }
    // Print test
    // setPrint(<TaskCommonDraftPrint />)
  }, [history.location]);

  return (
    <React.Fragment>
      <Router>
        <Switch>
          {authRoutes.map((route, idx) => (
            <NonAuthmiddleware
              path={route.path}
              layout={NonAuthLayout}
              component={route.component}
              key={idx}
            />
          ))}
          {adminRoutes.map((route, idx) => (
            <AdminAuthmiddleware
              path={route.path}
              layout={Layout}
              component={route.component}
              key={idx}
            />
          ))}
          {managerCompanyRoutes.map((route, idx) => (
            <ManagerCompanyAuthmiddleware
              path={route.path}
              layout={Layout}
              component={route.component}
              key={idx}
            />
          ))}
          {taxPortalRoutes.map((route, idx) => (
            <TaxPortalAuthmiddleware
              path={route.path}
              layout={Layout}
              component={route.component}
              key={idx}
            />
          ))}
          {payPortalRoutes.map((route, idx) => (
            <PayPortalAuthmiddleware
              path={route.path}
              layout={Layout}
              component={route.component}
              key={idx}
            />
          ))}
          {routes.map((route, idx) => (
            <Authmiddleware
              path={route.path}
              layout={Layout}
              component={route.component}
              key={idx}
            />
          ))}
        </Switch>
        <Common />

      </Router>
    </React.Fragment>
  );
};

export default App;
